// extracted by mini-css-extract-plugin
export default {"fieldsContainer":"Formbody_fieldsContainer__9nUk0"};